import * as React from "react";
import { USER_1_KOKORIN, USER_2_KOROVCHENO } from "../../../Pages/Home";
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { fetchWithAuth } from "../../../utils";

export default function BookingTable({
  selectedDate,
  activeUser,
  setActiveUser,
  setRequests,
  requests,
}) {
  const trainerMap = {
    [USER_1_KOKORIN.id]: USER_1_KOKORIN.label,
    [USER_2_KOROVCHENO.id]: USER_2_KOROVCHENO.label,
  };

  const [confirmDialog, setConfirmDialog] = React.useState({
    open: false,
    itemId: null,
  });
  const [showAlert, setShowAlert] = React.useState({});
  const [userModal, setUserModal] = React.useState({});
  const [search, setSearch] = React.useState("");

  const updateStatus = async (id, status) => {
    try {
      const res = await fetchWithAuth(
        "/api/requests/status",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, status }),
          credentials: "include",
        }
      );

      if (res.success) {
        setShowAlert({ id: "success", text: "Успішно!" });
        setTimeout(() => setShowAlert(null), 1000);
        setRequests((prev) =>
          prev.map((item) => (item._id === id ? { ...item, status } : item))
        );
      } else {
        setShowAlert({ id: "error", text: "Сталася помилка!" });
        setTimeout(() => setShowAlert(null), 1000);
        alert(res.error || "Не вдалося оновити статус");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const handleRejectClick = (id) => {
    setConfirmDialog({ open: true, itemId: id });
  };

  const handleConfirmReject = () => {
    updateStatus(confirmDialog.itemId, "failed");
    setConfirmDialog({ open: false, itemId: null });
  };

  const handleCancelReject = () => {
    setConfirmDialog({ open: false, itemId: null });
  };

  const filteredRequests = requests
    .filter(
      (item) =>
        (activeUser === null || activeUser.id === item.trainer) &&
        item.date === formatDate(selectedDate) &&
        [item.name, item.surname, item.phone, item.time, item.trainer]
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
    )
    .sort((a, b) => {
      if (a.status === "failed" && b.status !== "failed") return 1;
      if (a.status !== "failed" && b.status === "failed") return -1;
      return a.time.localeCompare(b.time);
    });

  const successCount = filteredRequests.filter(
    (item) => item.status === "success"
  ).length;
  const failedCount = filteredRequests.filter(
    (item) => item.status === "failed"
  ).length;
  const pendingCount = filteredRequests.length - successCount - failedCount;

  return (
    <section className="admin-card admin-requests-card">
      <div className="admin-card-header">
        <div>
          <div className="admin-section-kicker">Заявки</div>
          <h2>Список бронювань на день</h2>
        </div>
        <div className="admin-inline-stats">
          <div>
            <span>Усього</span>
            <strong>{filteredRequests.length}</strong>
          </div>
          <div>
            <span>Очікують</span>
            <strong>{pendingCount}</strong>
          </div>
          <div>
            <span>Підтверджено</span>
            <strong>{successCount}</strong>
          </div>
        </div>
      </div>

      <div className="admin-requests-toolbar">
        <div className="admin-filter-group">
          <div className="admin-filter-title">Показати заявки для</div>
          <div className="sort-admin-users">
            <button
              type="button"
              onClick={() => setActiveUser(null)}
              className={activeUser === null ? "selected" : ""}
            >
              Всі
            </button>
            <button
              type="button"
              onClick={() => setActiveUser(USER_1_KOKORIN)}
              className={activeUser?.id === USER_1_KOKORIN.id ? "selected" : ""}
            >
              {USER_1_KOKORIN.label}
            </button>
            <button
              type="button"
              onClick={() => setActiveUser(USER_2_KOROVCHENO)}
              className={activeUser?.id === USER_2_KOROVCHENO.id ? "selected" : ""}
            >
              {USER_2_KOROVCHENO.label}
            </button>
          </div>
        </div>

        <TextField
          label="Пошук по імені, телефону або часу"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          className="admin-search"
        />
      </div>

      {filteredRequests.length ? (
        <div className="admin-users-orders">
          {filteredRequests.map((item) => (
            <div key={item._id} className={"item " + (item.status || "")}>
              <div className="left">
                <div className="header-top">
                  <span className="person-name">
                    {item.name} {item.surname}
                  </span>
                  <span className="time-pill">{item.time}</span>
                </div>

                <div className="admin-request-meta">
                  <span>{item.phone}</span>
                  <span>{item.date}</span>
                  <span>{trainerMap[item.trainer] || item.trainer}</span>
                </div>

                {item.comment ? (
                  <div className="admin-request-comment">{item.comment}</div>
                ) : (
                  <div className="admin-request-comment muted">
                    Без коментаря від клієнта
                  </div>
                )}

                <div className="status">{item.status || "new"}</div>
              </div>

              <div className="rigth">
                <button
                  className="button-success"
                  onClick={() =>
                    item.status !== "success" && updateStatus(item._id, "success")
                  }
                >
                  Підтвердити
                </button>
                <button
                  className="button-failer"
                  onClick={() => {
                    if (item.status !== "failed") {
                      setUserModal(item);
                      handleRejectClick(item._id);
                    }
                  }}
                >
                  Відхилити
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-empty-state">
          <strong>На цю дату немає заявок</strong>
          <span>Спробуйте змінити тренера або очистити пошук.</span>
          <span>Відхилено сьогодні: {failedCount}</span>
        </div>
      )}

      {showAlert?.id && (
        <div className="alert-position">
          <Alert severity={showAlert.id === "success" ? "success" : "error"}>
            {showAlert.text}
          </Alert>
        </div>
      )}

      <Dialog open={confirmDialog.open} onClose={handleCancelReject}>
        <DialogTitle>Підтвердження</DialogTitle>
        <DialogContent>
          Ви дійсно хочете відхилити заявку? {userModal.name}{" "}
          {userModal.surname}, {userModal.time}-{userModal.date}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReject}>Скасувати</Button>
          <Button onClick={handleConfirmReject} color="error">
            Відхилити
          </Button>
        </DialogActions>
      </Dialog>
    </section>
  );
}
